module.exports = __webpack_public_path__ + "img/landing.adcb62d2.jpg";